var YouboraObject = require('../object')
var Log = require('../log')

/**
 * This class manages data storage for offline events in localStorage.
 *
 * @extends youbora.Emitter
 * @memberof youbora
 */
var OfflineStorage = YouboraObject.extend({
  constructor: function () {
    this.disabledStorage = false
    if (!localStorage) {
      Log.error('Youbora offline events need localStorage which is not supported by your browser.')
      this.disabledStorage = true
    } else {
      try {
        localStorage.setItem('youboraTestItem', 123)
        localStorage.removeItem('youboraTestItem')
      }
      catch (err) {
        Log.error('Youbora offline events need localStorage which is not supported by your browser or settings.')
        this.disabledStorage = true
        return null
      }
    }
    this.actualView = null
    //this.viewList = []
    this.givenIds = []
    this._getOldViewList()
  },

  _newView: function () {
    //search for first unused id
    var viewId = this._getValidId()

    // create empty view
    var viewName = 'youboraOffline.' + viewId
    localStorage.setItem(viewName, '')

    // add to viewlist
    this.viewList.push(viewId)
    localStorage.setItem('youboraOffline.views', this.viewList)

    // save the id
    this.actualView = viewId
  },

  addEvent: function (event, params) {
    if (this.disabledStorage) return null

    // if event is start, create new view
    if (event === "/start") this._newView()

    // if event is init, ignore
    if (event === "/init") return null

    // if we have no view discard
    if (!this.actualView) return null

    //create event object
    var fullEvent = "{\"request\":\"" + event.slice(1) + "\"," // {"request":"start",
    fullEvent += "\"unixtime\":" + Date.now() + "," // "unixtime":1499876515,
    for (var param in params) {
      if (params[param] === undefined) break
      fullEvent += "\"" + param + "\":" // "aParam":
      if (param === "code") {
        fullEvent += "\"" + "CODE_PLACEHOLDER" + "\"," // "CODE_PLACEHOLDER",
      } else if (param === "sessionId") {
        fullEvent += "\"" + "SESSION_PLACEHOLDER" + "\"," // "SESSION_PLACEHOLDER",
        // modify code to support offline with infinity
      } else if (typeof params[param] === "string") {
        fullEvent += "\"" + params[param] + "\"," // "aStringValue",
      } else if (typeof params[param] === "object") {
        fullEvent += "\"" + JSON.stringify(params[param]).replace(/"/g, "\\\"") + "\"," // json object
      } else {
        fullEvent += params[param] + ","  // 123, for example
      }
    }
    fullEvent = fullEvent.slice(0, -1) // remove the last comma
    fullEvent += "}"

    // get accumulated view object
    var viewName = 'youboraOffline.' + this.actualView
    var temp = localStorage.getItem(viewName)
    if (temp != "") temp = temp + ',' // comma between events

    // add the event
    localStorage.setItem(viewName, temp + fullEvent)
  },

  getView: function () {
    if (this.disabledStorage) return null
    if (this.viewList.length > this.givenIds.length) { // if we have any view not sent yet
      var position = 0
      while (true) {
        var idToSend = this.viewList[position]
        if (!this.givenIds.includes(idToSend)) {
          this.givenIds.push(idToSend)
          return ["[" + localStorage.getItem('youboraOffline.' + idToSend) + "]", idToSend]
        }
        position++
      }
    }
    return [null, null]
  },

  removeView: function (id) {
    if (this.disabledStorage) {
      return null
    }
    var storageItemName = 'youboraOffline.' + id
    localStorage.removeItem(storageItemName)
    var position = this.viewList.indexOf(id)
    if (position !== -1) this.viewList.splice(position, 1)
    position = this.givenIds.indexOf(id)
    if (position !== -1) this.givenIds.splice(position, 1)
    localStorage.setItem('youboraOffline.views', this.viewList.toString())
    if (id === this.actualView) this.actualView = null
  },

  _getOldViewList: function () {
    var stringList = ""
    if (localStorage['youboraOffline.views']) {
      stringList = localStorage.getItem('youboraOffline.views')
    } else {
      localStorage.setItem('youboraOffline.views', '')
    }

    if (stringList === "") {
      this.viewList = []
    } else {
      this.viewList = stringList.split(',')
    }
  },

  _getValidId: function () {
    // get a value not in the list
    var id = Math.floor(Math.random() * 1e8).toString()
    if (this.viewList.indexOf(id) >= 0) {
      return this._getValidId()
    }
    return id
  },

  sent: function () {
    this.givenIds = []
  }
})

module.exports = OfflineStorage
